<template>
	<div style="background: #fff;padding: 15px;">
		<div>
			<div class="filter-container">
				<div class="filter-item">
						<label class="label" style="white-space: nowrap;font-weight: 700;">关键字: </label>
						<el-input v-model="searchKey" placeholder="手机号、微信昵称、姓名" style="width:200px;margin-right:10px"></el-input>
						
						<label class="label" style="width: 70px;white-space: nowrap;">收益时间: </label>
						<el-date-picker v-model="startTime" type="datetime"	value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" default-time="00:00:00"
							placeholder="开始时间">
						</el-date-picker>
						<span style="margin: 0 10px;">~</span>
						<el-date-picker v-model="endTime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59"
							placeholder="结束时间">
						</el-date-picker>
				</div>
				
				<div class="filter-item">
						<label class="label" style="white-space: nowrap;">推手级别: </label>
						<el-select v-model="agentRoleId" clearable>
							<el-option label="全部" :value="null"></el-option>
							<el-option v-for="item in agentRoleSelectList" :key="item.Value" :label="item.Text" :value="item.Value">
							</el-option>
						</el-select>
						
						<el-button type="primary" style="margin-left: 15px;width: 90px;" @click="goodsSearch">查询</el-button>
						<el-button style="margin-left: 15px;width: 90px;" @click="exportlist">导出</el-button>
				</div>
				
			</div>

			<!-- 门店管理表格 -->
			<div class="table-container">
        <div class="totalStyle">
          <div>自营零售收益（元）：{{awardMoneys.AllMemberAwardMoney}}</div>
          <div>直销推售收益（元）：{{awardMoneys.AllMemberRecommendAwardMoney}}</div>
          <div>间推销售收益（元）：{{awardMoneys.AllMemberIndirectRecommendAwardMoney}}</div>
          <div>团队收益（元）：{{awardMoneys.AllMemberGroupAwardMoney}}</div>
        </div>
				<el-table :data="tableList" style="width: 100%;" v-loading="loading">
					<el-table-column label="推手" width="270px">
						<template slot-scope="scope">
							<div style="display: flex;align-items: center;">
								<img class="table-img" :src="scope.row.WxHeadUrl ? scope.row.WxHeadUrl : defaultHeader" >
								<div style="margin-left: 10px;">
                  <div class="table-name">{{scope.row.NameDisplay}}</div>
                  <div>{{scope.row.Phone}}</div>
                </div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="AgentRoleName" label="推手级别"></el-table-column>
					<el-table-column prop="MemberAwardMoney" label="自营零售"></el-table-column>
					<el-table-column prop="MemberRecommendAwardMoney" label="直销推售"></el-table-column>
					<el-table-column prop="MemberIndirectRecommendAwardMoney" label="间推销售"></el-table-column>
					<el-table-column prop="MemberGroupAwardMoney" label="团队收益"></el-table-column>
					<el-table-column label="操作" width="140">
						<template slot-scope="scope">
							<el-button type="text" @click="openDetile(scope.row.Phone)">收益明细</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div style="display:flex;justify-content:space-between;align-items:center;">
					<div style="display:flex;font-size: 12px;color: #606266;align-items:center;margin-left: 13px;">
					</div>
					<el-pagination v-if="Total" style="margin-top:20px;float:right;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
					 :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
					 :total="Total">
					</el-pagination>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import config from '@/config/index'
	import apiList from '@/api/other.js'
	export default {
		data() {
			return {
				loading: false,
				awardMoneys:{
					AllMemberAwardMoney: 0.00,
					AllMemberRecommendAwardMoney: 0.00,
					AllMemberIndirectRecommendAwardMoney: 0.00,
					AllMemberGroupAwardMoney: 0.00,
				},

				searchKey: '',
				startTime: '',
				endTime: '',
				agentRoleId: null,
				agentRoleSelectList: [],
				currentPage: 1,
				pageSize: 20,
				Total: 0,

				tableList: [],

				imgUrl: config.IMG_BASE,
				defaultHeader:config.DEFAULT_HEADER,
				exportUrl: config.EXPORT_URL,
			};
		},
		beforeMount() {
			this.initTime()
			this.getListData()
			this.getAgentRoleList()
		},
		methods: {
			initTime(){
				let date = new Date();
				let year = date.getFullYear();
				let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
				let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
				let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
				let minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
				let second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
				this.startTime = year + "-" + month + "-" + "01" + " " + "00:00:00";
				this.endTime = year + "-" + month + "-" + day + " " + hour+ ":" + minute+ ":" + second;
			},
			// awardMoneys
			async getListData() {
				this.loading = true
				try {
					let data = {
						Skip: (this.currentPage - 1) * this.pageSize,
						Take: this.pageSize, // 取的数据
						Keywords: this.searchKey,
						AgentRoleId: this.agentRoleId,
						StartTime: this.startTime,
						EndTime: this.endTime
					}
					let result = await apiList.agentIndex(data)

					this.awardMoneys = {
						AllMemberAwardMoney: result.Result.AllMemberAwardMoney.toFixed(2),
						AllMemberGroupAwardMoney: result.Result.AllMemberGroupAwardMoney.toFixed(2),
						AllMemberIndirectRecommendAwardMoney: result.Result.AllMemberIndirectRecommendAwardMoney.toFixed(2),
						AllMemberRecommendAwardMoney: result.Result.AllMemberRecommendAwardMoney.toFixed(2),
					}

					this.tableList = result.Result.Results
					this.Total = result.Result.Total
				} catch (e) {
					//TODO handle the exception
				}
				this.loading = false
			},
			async  getAgentRoleList() {
				try {
					let result = await apiList.agentInit()
					this.agentRoleSelectList = result.Result.AgentRoleSelectList
				} catch (e) {
				}
			},
			openDetile(phone){
        let url = '/agent/benefitDetail?phone=' + phone
				this.$common.openNewWindow(url)
			},
			goodsSearch() {
				this.currentPage = 1
				this.getListData()
			},
			async exportlist(){
				this.loading = true;
				try {
					let url = this.exportUrl + '/pc/commission/agent/export?' +
						'&Keywords=' + this.searchKey +
						'&StartTime=' + (this.startTime ? this.startTime: '' ) +
						'&EndTime=' + (this.endTime ? this.endTime: '' ) +
						'&AgentRoleId=' + (this.agentRoleId ?  this.agentRoleId: '' )
					window.open(url);
				} catch (error) {
					console.log(error);
				} finally {
					this.loading = false;
				}
			},

			// 切换显示条数
			handleSizeChange(val) {
				this.pageSize = val;
				this.getListData();
			},

			// 翻页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getListData();
			},
		},
	}
</script>

<style lang="less" scoped>
.table-container{
  .totalStyle {
    background: #f5f5f5;
    padding: 13px;
    font-size: 15px;
    div{
      display: inline-block;
			margin-right:50px;
    }
  }
  .table-img{
    width: 50px !important;
    object-fit: scale-down;
    border-radius: 100%;
  }
  .table-name{
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
